export type AesDecodeFn = (
    secret: string,
    iv: string
) => (cipherB64: string) => Promise<string>;

function base64ToBytes(base64: string): Uint8Array {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return bytes;
}

export const aesDecodeFn: AesDecodeFn =
    (secret, iv) => async cipherB64 => {
        const keyBytes = base64ToBytes(secret);
        const cryptoKey = await crypto.subtle.importKey(
            "raw",
            keyBytes,
            { name: "AES-GCM" },
            false,
            ["decrypt"]
        );

        const ivBytes = base64ToBytes(iv);
        const ctBytes = base64ToBytes(cipherB64);

        const plainBuffer = await crypto.subtle.decrypt(
            { name: "AES-GCM", iv: ivBytes },
            cryptoKey,
            ctBytes
        );

        return new TextDecoder().decode(plainBuffer);
    };